import { Suspense, lazy } from "react";
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";

const Home = lazy(() => import("../pages/home/page"));
const Empresa = lazy(() => import("../pages/empresa/page"));
const TV = lazy(() => import("../pages/servicos/tv/page"));
const TelefoniaFixa = lazy(() => import("../pages/servicos/telefonia-fixa/page"));
const TelefoniaMovel = lazy(() => import("../pages/servicos/telefonia-movel/page"));
const RedeMesh = lazy(() => import("../pages/servicos/rede-mesh/page"));
const InternetEmpresarial = lazy(() => import("../pages/servicos/internet-empresarial/page"));
const ProdutosAdicionais = lazy(() => import("../pages/servicos/produtos-adicionais/page"));
const OutrosServicos = lazy(() => import("../pages/servicos/outros/page"));
const Areas = lazy(() => import("../pages/areas-de-atuacao/page"));
const Blog = lazy(() => import("../pages/blog/page"));
const Contato = lazy(() => import("../pages/contato/page"));
const Planos = lazy(() => import("../pages/planos/page"));
const Faq = lazy(() => import("../pages/faq/page"));
const TrabalheConosco = lazy(() => import("../pages/trabalhe-conosco/page"));

const PageLoader = () => (
  <div className="min-h-screen flex items-center justify-center bg-white">
    <div className="flex flex-col items-center gap-3">
      <div className="w-8 h-8 border-2 border-[#EE920D] border-t-transparent rounded-full animate-spin" />
      <span className="text-xs text-gray-400 font-medium">Carregando...</span>
    </div>
  </div>
);

const routes: RouteObject[] = [
  { path: "/", element: <Suspense fallback={<PageLoader />}><Home /></Suspense> },
  { path: "/empresa", element: <Suspense fallback={<PageLoader />}><Empresa /></Suspense> },
  { path: "/servicos/tv", element: <Suspense fallback={<PageLoader />}><TV /></Suspense> },
  { path: "/servicos/telefonia-fixa", element: <Suspense fallback={<PageLoader />}><TelefoniaFixa /></Suspense> },
  { path: "/servicos/telefonia-movel", element: <Suspense fallback={<PageLoader />}><TelefoniaMovel /></Suspense> },
  { path: "/servicos/rede-mesh", element: <Suspense fallback={<PageLoader />}><RedeMesh /></Suspense> },
  { path: "/servicos/internet-empresarial", element: <Suspense fallback={<PageLoader />}><InternetEmpresarial /></Suspense> },
  { path: "/servicos/produtos-adicionais", element: <Suspense fallback={<PageLoader />}><ProdutosAdicionais /></Suspense> },
  { path: "/servicos/outros", element: <Suspense fallback={<PageLoader />}><OutrosServicos /></Suspense> },
  { path: "/areas-de-atuacao", element: <Suspense fallback={<PageLoader />}><Areas /></Suspense> },
  { path: "/blog", element: <Suspense fallback={<PageLoader />}><Blog /></Suspense> },
  { path: "/contato", element: <Suspense fallback={<PageLoader />}><Contato /></Suspense> },
  { path: "/planos", element: <Suspense fallback={<PageLoader />}><Planos /></Suspense> },
  { path: "/faq", element: <Suspense fallback={<PageLoader />}><Faq /></Suspense> },
  { path: "/trabalhe-conosco", element: <Suspense fallback={<PageLoader />}><TrabalheConosco /></Suspense> },
  { path: "*", element: <NotFound /> },
];

export default routes;
